import { render } from "./AppLogo.vue?vue&type=template&id=2e0a0e78"
const script = {}
script.render = render

export default script